export function isValidUrl() {
  const pathNameSplit = location.pathname.split("/");
  if (pathNameSplit.length !== 3) return false;

  return pathNameSplit[1] === "products";
}

export const mwcProductURL = (number: string) => {
  const mcd = number.slice(0, 5);
  const cpg = number.slice(5, 8);
  const pno = number.slice(8, 10);
  const ino = number.slice(10, 12);
  return `${import.meta.env.VITE_MWC_API_FQDN}/voi/wsg/wrt-5_mcd-${mcd}_cpg-${cpg}_pno-${pno}_ino-${ino}.html`;
};
